export class PendingDoc {

    public id: string = "0";
    public pending: boolean;
    public sent: boolean;
    public approved: boolean;
    public proofOfVaccine : boolean;

    public member_name: string;
    public member_id: string;

    public product_name: string;
    public product_id: string;

    public date: Date;

    public obs: string;

    constructor() {}

}